<template>
  <el-dialog
    title="新建公共账号"
    :visible.sync="visible"
    width="420px"
    :destroy-on-close="true"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <el-form-item label="科目类型" prop="userType">
        <el-select v-model="form.userType" placeholder="请选择科目类型" style="width: 100%">
          <el-option
            v-for="item in typeOptions"
            :key="item.code"
            :label="`${item.code} - ${item.name}`"
            :value="item.code"
            :disabled="existingTypes.includes(item.code)"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="可选" maxlength="200" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button size="small" type="primary" :loading="submitting" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '../api';

export default {
  name: 'PublicAccountCreateDialog',
  props: {
    value: { type: Boolean, default: false },
    existingTypes: { type: Array, default: () => [] },
    typeOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      submitting: false,
      form: { userType: null, remark: '' },
      rules: {
        userType: [{ required: true, message: '请选择科目类型', trigger: 'change' }],
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.form = { userType: null, remark: '' };
        this.$nextTick(() => {
          if (this.$refs.form) this.$refs.form.clearValidate();
        });
      }
    },
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        api
          .create({ userType: this.form.userType, remark: this.form.remark || undefined })
          .then((res) => {
            if (res && res.code === 0) {
              this.$message.success('创建成功');
              this.$emit('success');
              this.handleClose();
            } else {
              this.$message.error((res && res.msg) || '创建失败');
            }
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>
